import React, { useContext, useMemo } from 'react'
import { ConfirmationDialog } from '../../uiComponents/popups/confirmationDialog'
import { ProductTableActionKind, productTableContext } from './provider'
import { isArticle } from './utils'
import { useArchiveArticleMutation, useArchiveCategoryMutation } from '../reduxApi'
import { useTranslation, Trans } from 'translations'

interface Copy {
    title: string
    text: React.ReactNode | string
    onConfirm: () => void
}

const DeleteProduct = () => {
    const { t } = useTranslation()
    const { state, dispatch } = useContext(productTableContext)
    const closeModal = () => dispatch({ type: ProductTableActionKind.SET_PRODUCT_FOR_DELETING, payload: undefined })
    const [archiveArticle] = useArchiveArticleMutation()
    const [archiveCategory] = useArchiveCategoryMutation()

    const name =
        state.selectProductToDelete?.name['en'] ||
        state?.selectProductToDelete?.name[Object.keys(state.selectProductToDelete.name)?.[0]]

    const modalProps = useMemo((): Copy => {
        if (isArticle(state.selectProductToDelete)) {
            return {
                title: t('products.productTable.delete.productTitle'),
                text: (
                    <span>
                        <Trans
                            i18nKey="products.productTable.delete.productText"
                            values={{ name }}
                            components={{ b: <b /> }}
                        />
                    </span>
                ),
                onConfirm: () => {
                    archiveArticle({ uuid: state.selectProductToDelete?.id as string }).then(() => closeModal())
                },
            }
        }

        return {
            title: t('products.productTable.delete.categoryTitle'),
            text: (
                <span>
                    <Trans
                        i18nKey="products.productTable.delete.categoryText"
                        values={{ name }}
                        components={{ b: <b /> }}
                    />
                </span>
            ),
            onConfirm: () => {
                archiveCategory({ uuid: state.selectProductToDelete?.id as string }).then(() => closeModal())
            },
        }
    }, [state.selectProductToDelete])

    if (!state.selectProductToDelete) {
        return null
    }

    return (
        <ConfirmationDialog
            destructive
            title={modalProps.title}
            text={modalProps.text}
            buttonText={t('common.delete')}
            onCancel={closeModal}
            onConfirm={modalProps.onConfirm}
        />
    )
}

export default DeleteProduct
